import { IPackage, IPublicationPackagesState } from '../types';

export const mergePublicationPackages = (
  state: IPublicationPackagesState,
  packagesList: IPackage[],
): IPublicationPackagesState => {
  if (!state.changedByUser) {
    return { packagesList, changedByUser: false };
  }

  return {
    ...state,
    packagesList: packagesList.map(item => {
      const packageFromState = state.packagesList.find(stateItem => stateItem.id === item.id);

      // если пакет был выбран пользователем, то сохраняем его выбор
      if (packageFromState) {
        return { ...item, selected: packageFromState.selected };
      }

      return item;
    }),
  };
};
